// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__9Kmny","row":"Node_row__1nooP","label":"Node_label__4JvNU","footer":"Node_footer__38h-U"};